import { computed } from 'vue'
import { defineStore } from 'pinia'
import api from '@/libs/axios';
import { type Project, gpsSchema, divisionSchema } from '@/types/types'
import { useAlertStore, useUserStore } from '@/stores'
import { useStoreSyncer } from '@/composables/Store-syncer';
import * as yup from 'yup'
import router from '@/router'




//TODO this should just read, write, delete an entire project, backend does the work
export const useProjectStore = defineStore('projects', () => {
  //const cache = useCacheStore();
  const { fetchAll, update, remove, create, allItems, error, loading } = useStoreSyncer('/projects', 'projects'); 

  //const loading = ref(true);

  const allProjects = computed(()=>{
    console.log("...projectStore.allProjects() computed...");
    //return cache.getFromCache('projects') || [];
    return allItems.value;

  })

  /**
   * parse all projects into table format
   */
  const tableData = computed(()=>{
    console.log("..project store tableData computed...");
   // loading.value = true;
    //const data = cache.getFromCache('projects') || [];
   // console.log("...parseTableData()" + JSON.stringify(data));
    const mapped = allItems.value.map((proj) => {
    let temp = proj
    // console.log(".temp = " + JSON.stringify(temp));
    try {
      temp.customerName = proj.customer.invoiceName.trim();
    } catch (err) {
      // console.log(err);
      console.error('..trapped error mapping customername on Projects-table.parseTableData...');
      temp.customerName = 'empty';
    }
      return temp
    });
  //  loading.value = false;
  return mapped;

  })
  /*const loading = computed(()=>{
    return cache.loading;
  })*/
  
  /*const gpsSchema = yup.object({
    lat: yup.number(),
    lon: yup.number()
  })*/
  //Custom schema for new project, remove extra fields
  const newProjectSchema = yup.object({
    //id : yup.string().length(8).defined(),
    //created_on: yup.date().nullable().min(new Date(2020, 0, 1)),
    created_by: yup.string().required(),
    //modified_on: yup.date().nullable().min(new Date(2020, 0, 1)),
    streetAddress: yup.string().required(),
    city: yup
      .string()
      .required()
      .transform((currentValue) => currentValue[0].toUpperCase() + currentValue.slice(1)),
    province: yup.mixed().oneOf(['AB', 'BC', 'SK', 'MB', 'ON', 'NB', 'NS']).defined(),
    customer_id: yup.number().defined(),
    //customer : customerSchema.defined(),
    //status: yup.array().defined(),
    //gps: yup.object().default({'lat': 50, 'lon': -114}),
    gps: gpsSchema,
    scopes: yup.array(),
    description: yup.string().notRequired(),
    notes: yup.string().notRequired(),
    //photosLink: yup.string().notRequired(),
    tags: yup.array().notRequired(),
    //engineer: yup.string().required(),
    //drafter: yup.string().nullable(),
    //owner : yup.string().required(),
    //source : yup.string().required(),
    engineer_id: yup.number().defined(),
    owner_id: yup.number().defined(),
    drafter_id: yup.number().notRequired(),
    division : divisionSchema.defined()

  })

  const existingProjectSchema = yup.object({
    //id : yup.string().length(8).defined(),
    //created_on: yup.date().nullable().min(new Date(2020, 0, 1)),
    //created_by: yup.string().required(),
    //modified_on: yup.date().nullable().min(new Date(2020, 0, 1)),
    streetAddress: yup.string().required(),
    city: yup
      .string()
      .required()
      .transform((currentValue) => currentValue[0].toUpperCase() + currentValue.slice(1)),
    province: yup.mixed().oneOf(['AB', 'BC', 'SK', 'MB', 'ON', 'NB', 'NS']).defined(),
    customer_id: yup.number().defined(),
    //customer : customerSchema.defined(),
    status: yup.array().defined(),
    //gps: yup.object().default({'lat': 50, 'lon': -114}),
    gps: gpsSchema,
    scopes: yup.array(),
    description: yup.string().notRequired(),
    notes: yup.string().notRequired(),
    tags: yup.array().notRequired(),
    //engineer: yup.string().required(),
    //drafter: yup.string().nullable(),
    //owner : yup.string().required(),
    //source : yup.string().optional(),
    owner_id : yup.number().defined(),
    engineer_id : yup.number().defined(),
    drafter_id : yup.number().notRequired()
    //year : yup.number().notRequired()
  })

  /**
   * fetch from backend, reset cache of all objects
   */
  async function fetchAllProjects() {
    console.log('project store.fetchAll()....fetching from api/backend...')
    return await fetchAll();
/*
    loading.value = true;
    const alert = useAlertStore();
    alert.success("Refreshing projects from backend...");
    try {
      await cache.fetchAndWriteToCache('projects' ,'/projects');
      //allProjects.value = await cache.fetchFromApi('projects', '/projects');

      const response = await api.get('/projects', api.FORCE_FETCH);
      console.log('response from api is:...')
      console.log(response)
      allProjects.value = await response.data.projects;
      alert.success("Refreshing projects from backend...done!");
      alert.clear(1000);
      //setTimeout(() => {
      //  loading.value = false;
     // }, 1000)
      //return allProjects.value;
  

    } catch (error) {
      console.error(error)
      alert.error(error);
      alert.clear(3000);
      setTimeout(() => {
        loading.value = false;
      }, 3000)
    //  return [{ id: 'empty', projectName: 'nothing found' }]

    } 
    loading.value = false;
    return allProjects.value;
    */
  }

  /**
   * return a project from the store format into the types I have created
   * @returns Project
   */
  function getById(id: String): Promise<Project> {
    //console.log(`project store.getById(${id})..`)
    //check if allItems is empty array, ie not initialized
    /*if(allProjects.value.length === 0){
      await fetchAllProjects();
    }*/
    //read from computed allProjects:
    const foundProj =  allProjects.value.find(proj =>{
      return proj.id == id;
    });
    //console.log('....foundProj = ' + JSON.stringify(foundProj));
    return foundProj;
    /*
    //return parseIncoming(foundProj);
    const parsed = parseIncoming(foundProj);
    console.log("......parsed = " + JSON.stringify(parsed));
    return parsed;*/
 
  }

  /**
   * return all projectInfo from the store
   * TODO remove, this is the same as getAll???
   * @returns
   */
  async function getSearchData() {
    if (!allProjects.value) {
      await fetchAll()
    }
    console.log(
      'project store.getSearchData()....getting from store...allProjects[0] = ' +
      JSON.stringify(allProjects.value[0])
    )
    return allProjects.value
  }

  /**
   * write project changes to backend (update)
   * refresh the projects, or currentProject ?
   */
  async function writeChanges(proj: Project) {
    console.log('project store.writeChanges()...')
    return await update(proj, existingProjectSchema, 'project');
    
  }

  /**
   * create a new project, use yup validation
   */
  async function createProject(proj: Project) {
    console.log('project store.createProject: ' + JSON.stringify(proj))
    const userStore = useUserStore()
    const creator = userStore.currentEmail
    proj.created_by = creator;
    const created = await create(proj, newProjectSchema, 'project');
    console.log("..created = " + JSON.stringify(created));
    if(created){
      await createFolder(created);
    }else{
      console.log("...skipping project folder creation..")
    }
    await new Promise(resolve => setTimeout(()=>{
      router.push(`/projects/${created.id}/details`)
    }, 2000));
/*
    await waitFor(500);
    setTimeout(()=>{
      router.push(`/projects/${created.id}/details`);
    },2000)*/
  }

  /**
   * create project folder on google drive, run through api backend
   * return project with folderId field
   */
  async function createFolder(project: Project) {
    console.log('project store.createProjectfolder ' + JSON.stringify(project))
    //try form validation
    const payload = {
      projectId: project.id,
      year: project.year,
      province: project.province,
      folderName: project.name
    }

    const projFolderSchema = yup.object({
      projectId: yup.string().required(),
      year: yup.string().required(),
      province: yup.string().required(),
      folderName: yup.string().required()
    })

    const alert = useAlertStore()
    let parsed
    try {
      parsed = await projFolderSchema.validate(payload, { stripUnknown: true }) //remove extra fields
      console.log('parsed = ' + JSON.stringify(parsed))
    } catch (err) {
      //err.name; // => 'ValidationError'
      //err.errors; // => ['Deve ser maior que 18']
      console.log(err)
      alert.error(err)
      setTimeout(() => {
        alert.clear()
      }, 3000)
      return
    }
    //if form is valid:
    if (parsed) {
      //let response = null;
      api
        .post(`/gdrive/createProjectFolder`, parsed)
        .then((res) => {
          console.log("res.data.message :" + res.data.message);
          alert.success(res.data.message)
          setTimeout(async () => {
            alert.clear()
            //push to new project
            await fetchAll()
            //setCurrentProject(payload.projectId)

            const projectId = res.data.data.project.id
            router.push(`/projects/${projectId}/details`)
           // project = res.data.data.project;
           // return res.data.data.project;
          }, 3000)
        })
        .catch((error) => {
          console.error("error creating project folder :" + error.toString());
          if (error.response) {
            alert.error(error.response.data)
          } else if (error.request) {
            alert.error(error.request)
          }
        })
    }
  }
  /**
   * This will delete from the watchlist and active projects as
   * well as the backend
   * @param id 
   */
  async function deleteProject(id: Number) {
    console.log('projects store deleting project : ' + id)
    return await remove(id);
      /*if(deleted){
        const shortlistStore = useShortlistStore();
        await shortlistStore.remove(deleted.id);
        const watchlistStore = useWatchlistStore();
        await watchlistStore.remove(id);
      }
       // await createFolder(created)
      setTimeout(()=>{
        router.push('/projects/list');
      },2000)
        
      //}
    }catch(err){
      console.log(".error on deleting project, " + err);
      alert.error("error on deleting project.." + err);
    }
   */
  }

  //fetch the nearest n sites to a given project, for displaying on map
  //default is single nearest site
  async function getNearestSites(project: Project, n: number = 1) {
    console.log('projects store getNearestSites()....' + JSON.stringify(project));
    const lat = project.gps.lat
    const lon = project.gps.lon
    const projectId = project.id
    console.log('projectId = ' + projectId + ',  lat = ' + lat + ', lon = ' + lon) // + //", province =" + province);
    //const projects = await getAll()
    const arr = allProjects.value
      .map((site) => {
        const siteLat = parseFloat(site.gps.lat)
        const siteLon = parseFloat(site.gps.lon)
        site.delta = Math.pow(Math.pow(siteLat - lat, 2) + Math.pow(siteLon - lon, 2), 0.5)
        //console.log("delta = " + site.delta);
        return site
        //}).filter(site=>{
        //  site.id != projectId ? false : true;
      })
      .toSorted((a, b) => a.delta - b.delta) //.shift();

    //console.log(arr)
    if (!n || n === 0 || n === 1) {
      return [arr[0]]
    } else {
      return arr.slice(0, n) //first item should be the project, remove it
    }
  }

  /**
   * helper function to add a status to project if it doesnt already exist
   * @param proj
   * @param status 
   */
  async function addStatus(proj: Project, status: String) {
    //const tempProj = currentProject.projectInfo;
    const tempStatus = proj.status;
    if (!tempStatus.includes(status)) {
      tempStatus.push(status);
    }
    proj.status = tempStatus;
    await writeChanges(proj);

  }
  
  /**
   * fetch the table data from the view in the DB
   */
  async function fetchTableData(){
    console.log("project store fetchTableData()..");
    loading.value = true;
    const response = await api.get('/projects/view');
    loading.value = false;
    console.log("...response = " + response.data.status + " : " + response.data.message);
    return response.data.data.projects;
  }

  /**
   * fetch divisions
   */
  async function fetchDivisions(){
    loading.value = true;
    const response = await api.get('/divisions');
    loading.value =false;
    return response.data.data.divisions;
  }

  /**
   * fetch directly from api
   */
  async function fetchById(id : String): Promise<Project | null> {
    console.log(`projectStore.fetchById(${id})...`);
    loading.value = true;
    let fetched;
    try{
      const response = await api.get(`/projects/${id}`);
      loading.value = false;
      fetched = response.data.data.project;
      console.log("..fetched = " + JSON.stringify(fetched));
      return fetched;
    }catch(err){
      console.log(err);
      return null;
    }finally{
      loading.value = false;
    }

  }
  

  return {
    allProjects,
    fetchAllProjects,
    getById,
    //fetchById,
    getSearchData,
    writeChanges,
    createProject,
    createFolder,
    deleteProject,
    getNearestSites,
    addStatus,
    loading,
    tableData,
    fetchTableData,
    fetchDivisions,
    fetchById
  }
})

/**
 * parse the fetched project from db, ie manipulate
 * some fields
 * @param fetched
 *
function parseIncoming(fetched: any) {
  console.log(".....parsing incoming project in store...");
  const parsed: Project = {
    projectId: null,
    projectInfo: null,
    invoices: fetched.invoices,
    postechs: null
  }

  const projectInfo = {
    created_by: fetched.created_by,
    created_on: fetched.created_on,
    modified_on: fetched.modified_on,
    id: fetched.id,
    streetAddress: fetched.streetAddress,
    city: fetched.city,
    province: fetched.province,
    description: fetched.description,
    notes: fetched.notes,
    status: fetched.status,
    scopes: fetched.scopes,
    tags: fetched.tags,
    gps: fetched.gps, //JSON
    customer: fetched.customer,
    customerId: fetched.customer.id,
    projectName: fetched.projectName,
    folderId: fetched.folderId,
    engineer: fetched.engineer,
    drafter: fetched.drafter,
    year: fetched.year
  }

  parsed.projectInfo = projectInfo

  let postechArr = fetched.postechs
  try{
      postechArr.forEach((postech) => {
        const temp = postech.piles.items
        postech.piles = temp
      })
  }catch(err){
    console.log("..error parsing project postechArr... " + err);
    postechArr = [];
  }
 
  parsed.postechs = postechArr

  parsed.projectId = fetched.id

  return parsed
}*/

